export enum SigningAction {
    VIEW_PIN = 'VIEW_PIN',
    ACTIVATE_CARDS = 'ACTIVATE_CARDS',
    GRANT_PIN_VIEW = 'GRANT_PIN_VIEW'
}

export interface ActivateCardsSigningPayload {
    cardNumbers: string[];
}

export interface ViewPinSigningPayload {
    cardNumber: string;
}

export interface ContactPersonSigningPayload {
    personalIdentificationCode: string;
    fullName: string;
}